import { AccordionFieldsFragment } from "@src/generated/graphql";
import {
  highlightBracketedText,
  highlightUnderscoreText,
} from "src/utils/utils";
import CountUp from "react-countup";
import { useEffect, useRef, useState } from "react";
import { FiArrowRight } from "react-icons/fi";
import { DynamicLink } from "src/components/shared";

type SuperChargingProps = {
  content: AccordionFieldsFragment;
};

const SuperChargingComponent = ({ content }: SuperChargingProps) => {
  const { title, accordionItemsCollection, descriptionJson } = content;
  const items = accordionItemsCollection?.items || [];
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement | null>(null);


  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const parseStatValue = (text: string) => {
    const numMatch = text.match(/^\d+/);
    const number = numMatch ? parseFloat(numMatch[0]) : 0;
    const suffix = text.slice(numMatch ? numMatch[0].length : 0);
    return { number, suffix };
  };
  return (
    <section
      ref={sectionRef}
      className="box-corner-component"
      style={{ paddingTop: "100px", paddingBottom: "130px" }}
    >
      <div className="box-corner-content ps-0 pe-0 pt-0">
        <div className="container-fluid custom-spacer-col">
          <section className="box-number-count-component content2">
            <div className="component-title d-inline-block text-center ">
              <span
                className="highlight-bracket-text enterprise-supercharging-title"
                dangerouslySetInnerHTML={{
                  __html: highlightBracketedText(title ?? "", "bold"),
                }}
              />
              <div className="enterprise-supercharging-description-container">
                <p
                  className="enterprise-supercharging-description"
                  dangerouslySetInnerHTML={{
                    __html: highlightUnderscoreText(
                      descriptionJson?.json.content[0].content[0].value ?? ""
                    ),
                  }}
                />
              </div>
            </div>

            <div className="box-number-count">
              {items.map((item, index) => {
                const { number, suffix } = parseStatValue(item?.itemText || "");
                return (
                  <div className="count-value text-center" key={index}>
                    {item?.itemText?.trim() && (
                      <h2 className="black">
                        {isVisible && (
                          <CountUp end={number} duration={2} decimals={0} />
                        )}
                        {suffix}
                      </h2>
                    )}

                    <span className="fw-bold supercharging-text font-medium">
                      {item?.additionalItemText}
                    </span>
                    <p
                      className="supercharging-description"
                      style={{ fontSize: "15px", color: "#131327" }}
                    >
                      {
                        item?.itemDescriptionJson?.json.content[0].content[0]
                          .value
                      }
                    </p>
                   {item?.linkText &&  <DynamicLink
                      url={item?.linkUrl}
                      className="supercharging-link-text"
                     
                    >
                      {item?.linkText}
                      <FiArrowRight height={25} width={25} />
                    </DynamicLink>}
                  </div>
                );
              })}
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default SuperChargingComponent;
